import { errorMessage } from "helpers/utils";
import { call, put, takeEvery } from "redux-saga/effects";
import productService from "services/ProductService";
import {
  CREATE_LIST_PRODUCT_INVOICE,
  CREATE_PRODUCT_INVOICE,
  DELETE_PRODUCT_INVOICE,
  EDIT_PRODUCT_INVOICE,
  GET_ALL_PRODUCT_INVOICE,
  GET_DETAIL_PRODUCT_INVOICE,
  GET_LIST_PRODUCT_INVOICE,
  GET_LIST_VAT,
} from "./actionTypes";
import {
  createListProductInvoiceFail,
  createListProductInvoiceSuccess,
  createProductInvoiceFail,
  createProductInvoiceSuccess,
  deleteProductInvoiceFail,
  deleteProductInvoiceSuccess,
  editProductInvoiceFail,
  editProductInvoiceSuccess,
  getAllProductInvoiceFail,
  getAllProductInvoiceSuccess,
  getDetailProductInvoiceFail,
  getDetailProductInvoiceSuccess,
  getListProductInvoiceFail,
  getListProductInvoiceSuccess,
  getListVatFail,
  getListVatSuccess,
} from "./actions";

function* fetchGetProductInvoice({ params }) {
  try {
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    // Call api
    const response = yield call(
      productService.listItems,
      page,
      perPage,
      columnFilter,
      keywords,
      sort
    );
    const totalCount = response._meta.totalCount;
    yield put(getListProductInvoiceSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListProductInvoiceFail(errorMessage(error)));
  }
}

function* fetchGetDetailProductInvoice({ id }) {
  try {
    const response = yield call(productService.detailItems, id);
    // console.log("response", response);
    yield put(getDetailProductInvoiceSuccess(response));
  } catch (error) {
    yield put(getDetailProductInvoiceFail(errorMessage(error)));
  }
}

function* fetchCreateProductInvoice({ data }) {
  try {
    const response = yield call(productService.createItems, data);
    yield put(createProductInvoiceSuccess(response));
  } catch (error) {
    yield put(createProductInvoiceFail(errorMessage(error)));
  }
}

function* fetchCreateListProductInvoice({ data }) {
  try {
    let response = null;
    if (data && data.length > 0) {
      response = yield call(productService.createListItems, data);
    }
    yield put(createListProductInvoiceSuccess(response));
  } catch (error) {
    yield put(createListProductInvoiceFail(errorMessage(error)));
  }
}

function* fetchEditProductInvoice({ data, id }) {
  try {
    const response = yield call(productService.editItems, data, id);
    yield put(editProductInvoiceSuccess(response));
  } catch (error) {
    yield put(editProductInvoiceFail(errorMessage(error)));
  }
}

function* fetchDeleteProductInvoice({ id }) {
  try {
    const response = yield call(productService.deleteItems, id);
    // Wait XML generate
    yield put(deleteProductInvoiceSuccess(response));
  } catch (error) {
    yield put(deleteProductInvoiceFail(errorMessage(error)));
  }
}

function* fetchGetListVat({}) {
  try {
    const response = yield call(productService.listVats);
    const listVat = response.items.map(item => {
      return {
        value: item.id,
        label: item.ltsuat,
        id: item.id,
        vat_text: null,
      };
    });
    yield put(getListVatSuccess(listVat));
  } catch (error) {
    yield put(getListVatFail(errorMessage(error)));
  }
}

function* fetchGetAllProduct({}) {
  try {
    const response = yield call(productService.listAllProduct);
    const list = response.items.map(item => {
      return {
        ...item,
        value: item.name,
        label: item.code + " - " + item.name,
      };
    });
    yield put(getAllProductInvoiceSuccess(list));
  } catch (error) {
    yield put(getAllProductInvoiceFail(errorMessage(error)));
  }
}

function* productInvoiceSaga() {
  yield takeEvery(GET_LIST_PRODUCT_INVOICE, fetchGetProductInvoice);
  yield takeEvery(GET_DETAIL_PRODUCT_INVOICE, fetchGetDetailProductInvoice);
  yield takeEvery(CREATE_PRODUCT_INVOICE, fetchCreateProductInvoice);
  yield takeEvery(CREATE_LIST_PRODUCT_INVOICE, fetchCreateListProductInvoice);
  yield takeEvery(EDIT_PRODUCT_INVOICE, fetchEditProductInvoice);
  yield takeEvery(DELETE_PRODUCT_INVOICE, fetchDeleteProductInvoice);

  yield takeEvery(GET_LIST_VAT, fetchGetListVat);
  yield takeEvery(GET_ALL_PRODUCT_INVOICE, fetchGetAllProduct);
}

export default productInvoiceSaga;
